import React from 'react';
import { Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const wittyRemarks = [
  "Life is like a game of bridge... you need a good partner and a bit of luck!",
  "Keep calm and bid on.",
  "In bridge, as in life, it's not the cards you're dealt but how you play them.",
  "A finesse a day keeps the opponents at bay.",
  "Trust your partner, count your points, and never trump your partner's ace!",
  "Bridge: where making a grand slam feels grander than winning the lottery.",
  "Some days you're the declarer, some days you're the dummy.",
  "Bridge players never die, they just lose their finesse.",
  "When in doubt, lead trumps... or blame your partner.",
  "Four cards to happiness: a good hand, a great partner, and two confused opponents.",
  "Life's too short for weak two-bids.",
  "Bridge: the only place where being dummy is a good thing.",
  "May your finesses always work and your opponents always revoke.",
  "A bad day at bridge beats a good day at work.",
  "Friends don't let friends play 1NT with a singleton.",
];

const getRandomRemark = () => {
  return wittyRemarks[Math.floor(Math.random() * wittyRemarks.length)];
};

const formatDate = () => {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  return new Date().toLocaleDateString('en-IE', options);
};

const styles = {
  headerWrapper: {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    backgroundColor: 'white',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  topBar: {
    backgroundColor: '#3D6B59',
    padding: '12px 0',
  },
  topBarContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  navLink: {
    color: 'white',
    textDecoration: 'none',
    fontSize: '1.1rem',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 0',
    borderBottom: '2px solid transparent',
    transition: 'border-color 0.2s',
  },
  mainBar: {
    backgroundColor: 'white',
    padding: '15px 0',
    borderBottom: '1px solid #eee',
  },
  mainBarContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  logoIcon: {
    backgroundColor: '#3D6B59',
    borderRadius: '10px',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '12px',
  },
  logoSymbol: {
    color: 'white',
    fontSize: '1.8rem',
    fontWeight: 'bold',
  },
  logoText: {
    fontSize: '1.6rem',
    fontWeight: 'bold',
    color: '#333',
  },
  logoSubtext: {
    fontSize: '0.8rem',
    color: '#666',
    marginTop: '2px',
  },
  rightSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '4px',
  },
  dateDisplay: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: 'rgba(255,255,255,0.9)',
    fontSize: '0.9rem',
  },
  wittyRemark: {
    fontStyle: 'italic',
    color: '#666',
    fontSize: '0.95rem',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    maxWidth: '400px',
    textAlign: 'right',
  },
};

const Header = (props) => {
  const wittyRemark = getRandomRemark();

  return (
    <div style={styles.headerWrapper}>
      {/* Navigation Bar */}
      <div style={styles.topBar}>
        <div style={styles.topBarContent}>
          <nav style={styles.nav}>
            <Link style={styles.navLink} to="/">
              <Icon name="home" /> Home
            </Link>
            <Link style={styles.navLink} to="/events/results">
              Results
            </Link>
            <Link style={styles.navLink} to="/events">
              Games
            </Link>
            {props.isAuthenticated && (
              <Link style={styles.navLink} to="/events/list">
                Manage Games
              </Link>
            )}
          </nav>
          <nav style={styles.nav}>
            <span style={styles.dateDisplay}>
              <Icon name="calendar alternate outline" />
              {formatDate()}
            </span>
            <span style={{ color: 'rgba(255,255,255,0.4)', margin: '0 5px' }}>|</span>
            {props.isAuthenticated ? (
              <Link style={styles.navLink} to="/logout">
                <Icon name="sign out" /> Logout
              </Link>
            ) : (
              <Link style={styles.navLink} to="/login">
                <Icon name="sign in" /> Login
              </Link>
            )}
          </nav>
        </div>
      </div>

      {/* Main Bar with Logo */}
      <div style={styles.mainBar}>
        <div style={styles.mainBarContent}>
          <Link to="/" style={styles.logoContainer}>
            <div style={styles.logoIcon}>
              <span style={styles.logoSymbol}>♠</span>
            </div>
            <div>
              <div style={styles.logoText}>Bridgemate</div>
              <div style={styles.logoSubtext}>Regional Bridge Events</div>
            </div>
          </Link>
          <div style={styles.rightSection}>
            <div style={styles.wittyRemark}>
              <Icon name="quote left" style={{ opacity: 0.5 }} />
              {wittyRemark}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
